import { TranslationMessages } from "ra-core";
import englishMessages from 'ra-language-english';

const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  od: {
    action: {
      settings: 'Network Settings',
      systemalert: 'Notifications',
      help: 'Help',
      contactsupport: 'Contact Support',
    },
    appbar: {
      services_menu: 'Services',
      dbbackup: 'Database Backup',
      dbdeployments: 'Database Deployments',
      dbobfuscation: 'Database Encryption',
      dbgovernance: 'Data Governance',
      perftuning: 'Performance Tuning',
    },
  },
}

export default customEnglishMessages;
